<template>
    <div>
        <van-nav-bar title="工会小组联系人" />
        <div class="block_container">
            <br />
            <div v-for="(group,index) in groupInfo" :key="index">
                <div class="block_card">
                    <h3 class="van-ellipsis">{{group.name}}</h3>
                    <van-cell v-for="(lead,idx) in group.leaders" :key="idx"
                        :title="lead.name" icon="user-circle-o"
                        :label="lead.cecid"
                        style="text-align:left;padding: 10px 0px;"
                        :value="lead.address" :border="false" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { NavBar, Cell } from 'vant';

export default {
    name: 'Groups',
    data () {
      return {
          groupInfo: []
      }
    },
    mounted() {
        let vm = this;
        axios.get('/api/getGroups').then((res) => {
            vm.groupInfo = res.data;
        }).catch((error) => {
            alert("Internal server error!");
        });
    }
}
</script>
<style scoped>
.block_container {
    background-color: #f7f8fa;
    font-size: 14px;
    line-height: 26px;
}
.block_card {
    margin-bottom: 24px;
    padding: 24px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 12px #ebedf0;
}
h3 {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 18px;
    margin: 0;
    text-align:left;
}
</style>


// WEBPACK FOOTER //
// src/components/Groups.vue